module.exports = __webpack_public_path__ + "media/components/assets/images/tamgeulAllkill/cta1-5fa7fc180d10b21fd2e6e5ef706ea6fe.png";